import {
  REQUEST_MTUS_FOR_PAST_30_DAYS,
  REQUEST_MTUS_FOR_PAST_30_DAYS_ERROR,
  RECEIVE_MTUS_FOR_PAST_30_DAYS
} from 'actions'

const initialState = {
  data: {}
}

export default function last30Days (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case REQUEST_MTUS_FOR_PAST_30_DAYS:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.slug]: {
            ...state.data[payload.slug],
            isRequesting: true
          }
        }
      }
    case RECEIVE_MTUS_FOR_PAST_30_DAYS:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.slug]: {
            ...state.data[payload.slug],
            isRequesting: false,
            data: payload.response
          }
        }
      }
    case REQUEST_MTUS_FOR_PAST_30_DAYS_ERROR:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.slug]: {
            ...state.data[payload.slug],
            isRequesting: false,
            error: payload
          }
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/mtus/last-30-days.js